module.exports = __webpack_public_path__ + "img/open-ticket.595134b3.svg";